import { LinearGradient } from 'expo-linear-gradient';
import { StyleSheet, TouchableOpacity, TouchableOpacityProps } from 'react-native';

import { actuatedNormalizeHorizontal, actuatedNormalizeVertical } from '@/utils/pixelScaling';

interface Props extends TouchableOpacityProps {
  size?: number;
  borderColor?: string;
  borderWidth?: number;
}

const GradientCircularButton = (props: Props) => {
  const { size = 86, children, borderColor = '#EBEBEB', borderWidth = 6 } = props;

  const horizontalScaledSize = actuatedNormalizeHorizontal(size);
  const verticalScaledSize = actuatedNormalizeVertical(size);

  const finalSize = horizontalScaledSize > verticalScaledSize ? verticalScaledSize : horizontalScaledSize;

  return (
    <TouchableOpacity
      {...props}
      style={[
        {
          backgroundColor: borderColor,
          borderRadius: 100000,
          height: finalSize,
          width: finalSize,
          padding: borderWidth,
          maxHeight: 86,
          maxWidth: 86
        },
        props.style
      ]}>
      <LinearGradient style={[styles.container, { borderRadius: 100000 }]} colors={['#F6A604', '#F6DE04']}>
        {children}
      </LinearGradient>
    </TouchableOpacity>
  );
};

export default GradientCircularButton;

const styles = StyleSheet.create({
  container: {
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  }
});
